import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Model } from 'projects/core/src/include/model';
import { DossierPhase } from '../../../../dossier';
import { DossierPhasesService } from '../../../../services/dossierphases.service';
import { NotificationService } from 'projects/core/src/lib/notification.service';
import { Globals } from 'projects/core/src/globals';
import { ToastMode } from 'projects/core/src/include/structures';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css']
})
export class DetailPhaseComponent extends Model<DossierPhase> implements OnInit {

  override modulename="dossier";

  notifications=[];

  get notifyChangePhase(){
    if(this.module)
      return this.module.getParam("enableNotifyChangePhase",false);
    else
      return false;
  }


  constructor(
    private route1: ActivatedRoute,
    private dossierPhasesService: DossierPhasesService,
    private notificationService:NotificationService
  ) { 
    super(route1,dossierPhasesService);
  }

  ngOnInit(): void {

    this.title = 'Dettaglio Fase';
    super.ngOnInit.apply(this, arguments); 

    this.getItem();


    this.beforeSave = async (): Promise<boolean> => {

  // 1. Controllo duplicati locali
  const names: string[] = [];
  for (const s of this.record.sections) {
    for (const f of s.fields) {

      if (names.includes(f.name)) {
        Globals.message.showToaster("Nome campo '" + f.name + "' duplicato", ToastMode.DANGER);
        return false;
      }

      names.push(f.name);
    }
  }

  // 2. Controllo duplicati sul server (asincrono)
  try {
    // Trasformiamo la chiamata in Promise con await
    const res: string[] = await new Promise((resolve) => {
      this.dossierPhasesService.checkDuplicateNameField(
        names,
        this.record.id_type,
        this.record.id,
        (duplicates: string[]) => resolve(duplicates)
      );
    });

    if (res.length === 0) {
      return true;
    } else {
      Globals.message.showToaster(
        "Nome dei campi duplicati per la tipologia di pratica: " + res.join(", "),
        ToastMode.DANGER
      );
      return false;
    }
  } catch (error) {
    Globals.message.showToaster("Errore durante la verifica dei campi duplicati", ToastMode.DANGER);
    return false;
  }
};

    this.afterGetItem=()=>{
      if(this.record.alarms)
        if(!Array.isArray(this.record.alarms)){
          try{
            this.record.alarms=JSON.parse(this.record.alarms);
          }catch{
            this.record.alarms=[];
          }
          
        }
      else
        this.record.alarms=[];
    }

    this.notificationService.getNotifications("dossier",0).subscribe((result)=>{
      this.notifications=result;
    })
   
  }


  addAlarm(){
    let a:any={};
    a.id_notification=0;
    a.condition="";
    a.description="";
    a.days="";
    a.date="";

    if(!Array.isArray(this.record.alarms)){
      this.record.alarms=[];
    }

    this.record.alarms.push(a);
  }

  deleteAlarm(a){
    for(let i=0;i<this.record.alarms.length;i++){
      if(this.record.alarms[i]==a){
        this.record.alarms.splice(i,1);
        return;
      }
    }
  }

}
